import * as Types from "../constants/Types";

const initialState = {
  isFetching: false,
  statusDelete: null,
  data: {
    listRedisKey: [],
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.CACHE_LIST_ACTION:
      return { ...state, isFetching: true };
    case Types.CACHE_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          listRedisKey: action.rediscache.result,
        },
      };
    case Types.CACHE_LIST_FAIL:
      return {
        ...state,
        isFetching: false,
        data: {
          listRedisKey: [],
        },
      };
    case Types.CACHE_DELETE_ACTION:
      return { ...state, statusDelete: "deleting" };

    case Types.CACHE_DELETE_SUCCESS:
      return { ...state, statusDelete: "deleted" };

    default:
      return state;
  }
};
